import React from 'react';
import { Tag } from 'antd';

import { DATA_SENSITIVITY_COLORS, DataSensitivityLevelId } from '@sonar-software/sonar-core';

export interface DataSensitivityLevelTagProps {
	dataSensitivityLevelId: DataSensitivityLevelId | undefined;
}

export const DataSensitivityLevelTag: React.FC<DataSensitivityLevelTagProps> = ({ dataSensitivityLevelId }) => {
	if (dataSensitivityLevelId === undefined) {
		return null;
	}

	const label = DataSensitivityLevelId[ dataSensitivityLevelId ];
	const dataSensitivityTagColor = DATA_SENSITIVITY_COLORS[ dataSensitivityLevelId ];

	return dataSensitivityLevelId === DataSensitivityLevelId.None ?
		label : <Tag color={ dataSensitivityTagColor }>{ label }</Tag>;
};
